import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Toaster } from 'react-hot-toast';
import { Analytics } from '@vercel/analytics/react';

const RootLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 flex flex-col">
      <Navbar />
      {/* Main Content */}
      <main className="pt-16 flex-grow">
        <Outlet />
      </main>
      <Footer />
      
      {/* 修改 Toaster 配置 */}
      <Toaster 
        position="top-left"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#333',
            color: '#fff',
            padding: '12px 16px',
          },
          className: 'transform transition-all duration-300',
        }}
        gutter={8}
        containerStyle={{
          top: 40,
          left: 20,
        }}
        containerClassName="toast-container"
      />
      
      <Analytics />
    </div>
  );
};

export default RootLayout; 